export function download() {
	try {
		const { VUE_APP_ENVIRONMENT } = window.APP_ENV;

		if (VUE_APP_ENVIRONMENT === 'online') {
			fbq('trackCustom', 'Download');
			return;
		}
	}
	catch(err) {
		console.log(err);
	}
}